/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (locations) => ({
    type: actions.LOCATIONS_RECEIVE,
    payload: { locations },
});